import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import Badge from "react-bootstrap/Badge";
import ModalComponent from "../../components/UI/Modal/Modal";
import DynamicFormBuilder from "../../components/DynamicFormBuilder/DynamicFormBuilder";
import getAttachments from "../../api/formsApi/getAttachments";
import returnBadgeVariant from "../../helperFunctions/componentStyleHelper/componentStyleHelper";
import axiosInstance from "../../api/utils/axiosInstance";
import SearchComponent from "../../components/UI/SearchComponent/SearchComponent";
import fetchAllForms from "../../api/formsApi/fetchAllForms";
import getStatus from "../../api/formsApi/getStatus";
import { Pagination, Spin } from "antd";
import oibValidation from "../../helperFunctions/oibValidation/oibValidation";
import { toast } from "react-toastify";
import { Menu, Dropdown, Button } from "antd";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import { connect } from "react-redux";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import Spinner from "../../components/UI/Spinner/Spinner";
import "./PregledZahtjeva.css";
import {
  ZoomInOutlined,
  EditOutlined,
  FormOutlined,
  PaperClipOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { SignatureModal } from "../Signature/SignatureModal";

class PregledZahtjeva extends Component {
  state = {
    dataFetched: false,
    authKeyData: {},
    showConfirmationModal: false,
    countryList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    formListData: [],
    modal: false,
    updateModal: false,
    requestsLoaded: false,
    attachmentsForDelete: [],
    zahtjevId: null,
    zahtjevAtrId: null,
    initialFormData: [],
    update: false,
    readOnly: true,
    selectedFiles: [],
    searchModal: true,
    overview: true,
    modalTitle: "",
    attachments: [],
    dropDownData: [],
    requestType: [],
    vrstaDokumentaZaPotpis: "",
    status: "",
    isLoading: false,
    searchData: {
      searchText: "",
      status: "",
      formName: "",
      initialItemCount: 1,
    },
    secondaryOib: {
      invalidOib: false,
      value: "",
    },

    showSignatureConfirmation: false,
  };

  componentDidMount = () => {
    this.getInitialData();
  };

  getInitialData = async () => {
    try {
      let fetchStatuses = await getStatus("/sifarnici/statuses");
      let fetchStatusesData = fetchStatuses.data;
      let fetchFormsData = await fetchAllForms("forms/all?filterByLegalType=true");
      let formsDataFetched = fetchFormsData.data;

      const filteredData = formsDataFetched.filter((x) => x.formId !== 3);
      formsDataFetched = (this.props.authority.ZAHTJEV_ODOBRENJE_REV_DRUSTVO === "false" && this.props.role === "ROLE_KORISNIK" ? filteredData : formsDataFetched);

      this.setState({
        dropDownData: fetchStatusesData,
        requestType: formsDataFetched,
      });
    } catch (e) {
      throw e;
    }
  };

  setInitialFormData = (data) => {
    this.setState(
      {
        formId: data.formId,
        initialFormData: data,
        modalTitle: data.formDescription,
      },
      () => {
        this.getCountryList();
      }
    );
  };

  fetchForms = async (url) => {
    const res = await fetchFormsApi(url);
    const { data } = res;
    this.setInitialFormData(data, url);
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCityAndMuncipalityList();
      }
    );
  };

  getCityAndMuncipalityList = async () => {
    const gradExists = this.state.initialFormData.groupList.map((element) =>
      element.controlList.find((grad) => grad.controlLabel === "Naziv grada")
    );
    // .map(el => el)
    if (gradExists[0]) {
      const { data } = await axiosInstance.get(`/sifarnici/gradOpcina`);
      this.setState(
        {
          cityAndMuncipalityList: data,
        },
        () => {
          this.getDistrictList();
        }
      );
    } else {
      this.getDistrictList();
    }
  };

  getDistrictList = async () => {
    const naseljeExists = this.state.initialFormData.groupList.map((element) =>
      element.controlList.find(
        (naselje) => naselje.controlLabel === "Naziv mjesta"
      )
    );
    // .find(naselje => naselje.controlLabel === "Naziv naselja");

    if (naseljeExists[0]) {
      const { data } = await axiosInstance.get(`/sifarnici/naselja`);
      this.setState({ districtList: data, requestsLoaded: true });
    } else {
      this.setState({
        requestsLoaded: true,
      });
    }
  };

  openModal = (id, zahtjevAtrId, e) => {
    e.preventDefault();
    getAttachments("/attachments", id).then((res) => {
      this.setState(
        {
          ...this.state,
          modal: true,
          //
          update: false,
          overview: true,
          initialFormData: [],
          modalTitle: "",
          requestsLoaded: false,
          readOnly: true,
          selectedFiles: false,
          //
          zahtjevId: id,
          zahtjevAtrId: zahtjevAtrId,
          attachments: res.data.sort((a, b) => a.controlIndex - b.controlIndex),
        },
        () => {
          this.fetchForms(`/request/${zahtjevAtrId}?isEdit=${false}`);
        }
      );
    });
  };

  hideModal = () => {
    this.setState({
      ...this.state,
      modal: false,
    });
  };

  openConfirmationModal = () => {
    this.setState({ showConfirmationModal: true });
  };

  hideConfirmationModal = () => {
    this.setState({ showConfirmationModal: false });
  };

  downloadZahtjevPdf = (e, zahtjevId, zahtjevAtrId) => {
    axiosInstance
      .get(`/print/printZahtjev?zahtjevAtrId=${zahtjevAtrId}`, {
        responseType: "blob",
      })
      // axios({
      //   url: BASE_URL + "/print/printZahtjev?zahtjevAtrId=" + zahtjevAtrId,
      //   method: "GET",
      //   responseType: "blob"
      // })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", zahtjevAtrId + "_zahtjev" + ".pdf");
        document.body.appendChild(link);
        link.click();
      });
  };

  downloadRjesenjePdf = (e, zahtjevAtrId) => {
    axiosInstance
      .get(`/print/printRjesenje?zahtjevAtrId=${zahtjevAtrId}`)
      .then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([this.b64toBlob(response.data.blob)])
        );
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute(
          "download",
          zahtjevAtrId + "_rjesenje." + response.data.extension
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        toast.info("Dokument nije prenesen.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  searchInputHandler = (e) => {
    e.persist();
    const searchText = e.target.id;
    const inputValue = e.target.value;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        [searchText]: inputValue,
      },
    }));
  };

  statusDropdownHandler = (e) => {
    if (e.target.value === "SVI STATUSI") {
      this.setState((prevState) => ({
        searchData: {
          ...prevState.searchData,
          status: "",
        },
      }));
      return;
    }
    e.persist();
    const status = e.target.value;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        status,
      },
    }));
  };

  valueDropdownHandler = (e) => {
    if (e.target.value === "SVI ZAHTJEVI") {
      this.setState((prevState) => ({
        searchData: {
          ...prevState.searchData,
          formName: "",
        },
      }));
      return;
    }
    e.persist();
    const formName = e.target.value;
    this.setState((prevState) => ({
      searchData: {
        ...prevState.searchData,
        formName,
      },
    }));
  };

  submitHandler = (e) => {
    e.preventDefault();
    this.getSearchData();
  };

  getSearchData = () => {
    this.setState({ isLoading: true }, async () => {
      const timeout = setTimeout(async () => {
        try {
          const res = await axiosInstance.get(
            `/search/request?formId=${this.state.searchData.formName}&status=${this.state.searchData.status}&pojam=${this.state.searchData.searchText}&page=1&offset=10`
          );
          const { data } = res;
          if (data.result.length < 1) {
            this.setState({ error: true, isLoading: false });
            this.props.formSubmitError(true, "Za navedene parametre nema podataka.");
            return;
          }

          this.setState({
            formListData: data.result,
            dataFetched: true,
            searchModal: false,
            isLoading: false,
            searchData: { ...this.state.searchData, initialItemCount: res.data.size },
          });
        } catch (e) {
          this.setState({ isLoading: false })
          console.log(e)
        } finally {
          clearTimeout(timeout)

        }
      }, 500)


    })

  };

  onPageChanged = (page, pageSize) => {
    let url = `/search/request?formId=${this.state.searchData.formName}
      &status=${this.state.searchData.status}&pojam=${this.state.searchData.searchText
      }&&page=${page}&offset=${10}`;
    axiosInstance.get(url).then((res) => {
      this.setState({ formListData: res.data.result });
    });
  };

  setSelectedDate = (date) => {
    this.setState(date);
  };

  setUserInputState = (userInputObj, isOib, value) => {
    this.setState(userInputObj, () => {
      isOib && this.validateOib(value);
    });
  };

  validateOib = (oib) => {
    let checkOibValidity = oibValidation(oib);
    oib &&
      // !checkOibValidity &&
      this.setState({
        invalidOib: !checkOibValidity,
      });
  };

  dropdownHandler = (e) => {
    e.persist();
    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((element) => {
            return {
              ...element,
              controlList: [
                ...element.controlList.map((el) => {
                  return el.uuid == e.target.id
                    ? {
                      ...el,
                      value: e.target.value,
                    }
                    : el;
                }),
              ],
            };
          }),
        ],
      },
    }));
  };

  setSelectedFiles = (selectedFiles) => {
    if (selectedFiles.file === undefined) {
      return;
    }
    let newState = { ...this.state };
    let test = newState.selectedFiles.find(
      (element) => element.id === selectedFiles.id
    );

    let elementExists = test === undefined ? false : true;
    let newSelectedFiles = [...this.state.selectedFiles];
    if (!elementExists) {
      newSelectedFiles.push(selectedFiles);
    } else {
      let itemIndex = newSelectedFiles.findIndex(
        (element) => element.id === selectedFiles.id
      );
      newSelectedFiles[itemIndex] = selectedFiles;
    }

    this.setState({ ...this.state, selectedFiles: newSelectedFiles });
  };

  removeSelectedFile = (id) => {
    this.setState((prevState) => ({
      selectedFiles: [
        ...prevState.selectedFiles.filter((element) => element.id != id),
      ],
    }));
  };

  submitForm = (error) => {
    if (error) {
      this.props.formSubmitError(true, "Popunite obavezna polja!");
      this.setState({
        ...this.state,
        error,
      });
    }
  };

  resetCountryValue = (objData) => {
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel ===
                        "Naziv države" &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: "",
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetGradValue(objData);
      }
    );
  };

  autocompleteCountryHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      // this.resetCountryValue(objData);
      return;
    }

    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel === objData.id &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: selectedValue.sifDrzave.toString(),
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetGradValue(objData);
      }
    );
  };

  resetGradValue = (objData) => {
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel ===
                        "Naziv grada" &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: "",
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetNaseljeValue(objData);
      }
    );
  };

  resetNaseljeValue = (objData) => {
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel ===
                        "Naziv mjesta" &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: "",
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetPbrValue(objData);
      }
    );
  };

  resetPbrValue = (objData) => {
    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((groupListElement) => {
            return {
              ...groupListElement,
              controlList: [
                ...groupListElement.controlList.map(
                  (controlListElement, indx) => {
                    return controlListElement.controlLabel ===
                      "Poštanski broj" &&
                      controlListElement.addressGroup === objData.addressGroup
                      ? {
                        ...controlListElement,
                        value: "",
                      }
                      : controlListElement;
                  }
                ),
              ],
            };
          }),
        ],
      },
    }));
  };

  autocompleteCityHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      this.resetGradValue(objData);
      return;
    }

    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel === objData.id &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: selectedValue.sifGrdOpc.toString(),
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetNaseljeValue(objData);
      }
    );
  };

  autocompleteDistrictHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      this.resetNaseljeValue(objData);
      return;
    }
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel === objData.id &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: selectedValue.sifNaselja.toString(),
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.autocompletePbrHandler(selectedValue, objData);
      }
    );
  };

  autocompletePbrHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      this.resetPbrValue(objData);
      return;
    }
    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((groupListElement) => {
            return {
              ...groupListElement,
              controlList: [
                ...groupListElement.controlList.map(
                  (controlListElement, indx) => {
                    return controlListElement.controlLabel ===
                      "Poštanski broj" &&
                      controlListElement.addressGroup === objData.addressGroup
                      ? {
                        ...controlListElement,
                        value: selectedValue.brPoste,
                      }
                      : controlListElement;
                  }
                ),
              ],
            };
          }),
        ],
      },
    }));
  };

  openSignatureConfirmationModal = (zahtjevAtrId, vrstaDokumentaZaPotpis) => {
    let shouldConfirm = true;
    if(this.state.update && this.props.role !== "ROLE_KORISNIK"){
      shouldConfirm = false;
    }
    this.setState({
      showSignatureConfirmation: shouldConfirm,
      zahtjevAtrId: zahtjevAtrId,
      vrstaDokumentaZaPotpis: vrstaDokumentaZaPotpis
    });
  }

  closeSignatureConfirmationModal = () => {
    this.setState({
      showSignatureConfirmation: false,
      zahtjevAtrId: "",
    })
  }

  getSignedDocument = async () => {
    this.closeSignatureConfirmationModal();
    this.getInitialData();
    this.getSearchData();
  };

  removeAttachment = (id) => (e) => {
    e.preventDefault();

    const attachments = [...this.state.attachments];
    const filterAttachments = attachments.filter(
      (element) => element.controlIndex !== id
    );
    const findAttachmentsForDelete = attachments.find(
      (element) => element.controlIndex == id
    );

    const { attachmentsForDelete } = this.state;

    attachmentsForDelete.push(findAttachmentsForDelete);

    this.setState({
      attachments: filterAttachments,
      attachmentsForDelete,
    });
  };

  //update
  openUpdateModal = (id, zahtjevAtrId, e) => {
    e.preventDefault();
    getAttachments("/attachments", id).then((res) => {
      this.setState(
        {
          ...this.state,
          initialFormData: [],
          updateModal: true,
          modalTitle: "",
          requestsLoaded: false,
          overview: false,
          readOnly: false,
          update: true,
          selectedFiles: [],
          zahtjevId: id,
          zahtjevAtrId: zahtjevAtrId,
          attachments: res.data,
        },
        () => {
          this.fetchForms(`/request/${zahtjevAtrId}?isEdit=${true}`);
        }
      );
    });
  };

  hideUpdateModal = () => {
    this.setState({
      updateModal: false,
      showConfirmationModal: false,
      attachmentsForDelete: [],
      selectedFiles: [],
    });
  };

  render() {
    const { isAuthenticated, userData } = this.props;
    const userRole = userData != null ? userData.roles[0].roleName : null;

    const searchProps = {
      setSelectedDate: this.setSelectedDate,
      setUserInputState: this.setUserInputState,
      dropdownHandler: this.dropdownHandler,
      setSelectedFiles: this.setSelectedFiles,
      submitForm: this.submitForm,
      hideModal: this.hideUpdateModal,
      getSearchData: this.getSearchData,
      removeSelectedFile: this.removeSelectedFile,
      openSignatureConfirmationModal: this.openSignatureConfirmationModal,
    };

    let parentState = { ...this.state };
    let statusOptions = parentState.dropDownData.map((element) => (
      <option key={element.id} value={element.id}>
        {element.value}
      </option>
    ));

    let formOptions = parentState.requestType.map((element) => (
      <option key={element.formId} value={element.formId}>
        {element.formDescription}
      </option>
    ));

    return (
      <>
        {/* <ModalComponent
          size="xl"
          show={this.state.searchModal}
          onHide={this.hideSearchModal}
        > */}
        <SearchComponent
          // borderStyle={"none"}
          dropdownLabel={"Odaberite zahtjev"}
          onSubmit={this.submitHandler}
          searchHandler={this.searchInputHandler}
          searchValue={this.state.searchData.searchText}
          statusDropdownHandler={this.statusDropdownHandler}
          dropdownValue={this.state.searchData.status}
          statusOptions={statusOptions}
          valueDropdownHandler={this.valueDropdownHandler}
          formOptions={formOptions}
          text={"SVI ZAHTJEVI"}
          isLoading={this.state.isLoading}
        />
        {/* </ModalComponent> */}

        {this.state.formListData && this.state.formListData.length > 0 && (
          <>
            <Row className="justify-content-left">
              <Col>
                <div className="table-responsive">
                  <Table
                    bordered
                    hover
                    style={{ border: "0px" }}
                  >
                    <thead>
                      <tr className="tr_table">
                        <th className="text-center">Zahtjev</th>
                        <th scope="col">Naziv / Ime i prezime</th>
                        <th scope="col">OIB</th>
                        <th scope="col">Klasifikacijski broj</th>
                        <th scope="col">Datum podnošenja</th>
                        <th scope="col">Datum zaprimanja</th>
                        <th className="text-center">Pregled</th>
                        <th className="text-center">Ažuriranje</th>
                        <th scope="col">Dokumenti</th>
                        {userRole === "ROLE_SLUZBENIK" ? (
                          <th scope="col">Potpiši izlazni dokument / akt</th>
                        ) : userRole === "ROLE_KORISNIK" ? (
                          <th scope="col">Potpiši Zahtjev</th>
                        ) : null}
                        <th scope="col">Status zahtjeva</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.formListData.map((element, index) => {
                        let imePrezime =
                          element.ime && element.prezime ? (
                            element.ime + " " + element.prezime
                          ) : (
                            <i>Podatak nije unesen.</i>
                          );

                        let konacniNaziv = element.nazivSubjekta
                          ? element.nazivSubjekta
                          : imePrezime;

                        return (
                          <tr
                            key={`pregledZahtjeva${element.zahtjevAtrId}${index}`}
                          >
                            {/* VRSTA ZAHTJEVA */}
                            <td>{element.formDescription}</td>

                            {/* NAZIV ZAHTJEVA */}
                            <td>{konacniNaziv}</td>

                            {/* OIB SUBJEKTA */}
                            <td x-ms-format-detection="none">
                              {element.oib ? element.oib : "-"}
                            </td>

                            {/* KLASA ZAHTJEVA */}
                            <td>{element.klasa ? element.klasa : "-"}</td>

                            {/* DATUM PODNOŠENJA ZAHTJEVA */}
                            <td>
                              {moment(element.datPodnosenja).format(
                                "DD.MM.YYYY"
                              )}
                            </td>

                            {/* DATUM ZAPRIMANJA ZAHTJEVA */}
                            <td>
                              {moment(element.datZaprimanja).format(
                                "DD.MM.YYYY"
                              )}
                            </td>

                            {/* BUTTON ZA OTVARANJE DETALJA ZAHTJEVA */}
                            <td className="ant_batn">
                              <ButtonComponent
                                id={`ant-button-details-modal${element.zahtjevId}${index}`}
                                variant="secondary"
                                size="sm"
                                onClick={(e) => {
                                  this.openModal(
                                    element.zahtjevId,
                                    element.zahtjevAtrId,
                                    e
                                  );
                                }}
                              >
                                <ZoomInOutlined id={`${index}`} />
                              </ButtonComponent>
                            </td>

                            {/* BUTTON ZA AŽURIRANJE ZAHTJEVA */}
                            <td className="ant_batn">
                              <ButtonComponent
                                id={`update-button-${element.zahtjevId}`}
                                variant="secondary"
                                size="sm"
                                onClick={(e) => {
                                  this.openUpdateModal(
                                    element.zahtjevId,
                                    element.zahtjevAtrId,
                                    e
                                  );
                                }}
                                disabled={
                                  element.status != 1
                                    ? element.status == 3
                                      ? false
                                      : true
                                    : element.zahtjevPotpisan == 1
                                      ? true
                                      : false
                                }
                              >
                                <EditOutlined />
                              </ButtonComponent>
                            </td>

                            {/* DROPDOWN ZA PREUZIMANJE ZAHTJEVA / RJEŠENJA */}
                            <td>
                              <Dropdown
                                getPopupContainer={(trigger) =>
                                  trigger.parentNode
                                }
                                overlay={
                                  <Menu>
                                    <Menu.Item
                                      key="1"
                                      icon={<PaperClipOutlined />}
                                      onClick={(e) =>
                                        this.downloadZahtjevPdf(
                                          e,
                                          element.zahtjevId,
                                          element.zahtjevAtrId
                                        )
                                      }
                                    >
                                      Zahtjev
                                    </Menu.Item>
                                    {element.isRjesenjeDokument === 1 ? (
                                      <Menu.Item
                                        key="2"
                                        icon={<PaperClipOutlined />}
                                        onClick={(e) =>
                                          this.downloadRjesenjePdf(
                                            e,
                                            element.zahtjevAtrId
                                          )
                                        }
                                      >
                                        Izlazni dokument/akt
                                      </Menu.Item>
                                    ) : null}
                                  </Menu>
                                }
                              >
                                <Button>
                                  <div className="dropdown-arrow">
                                    Preuzmi <DownOutlined />
                                  </div>
                                </Button>
                              </Dropdown>
                            </td>

                            {/* BUTTON ZA POTPIS ZAHTJEVA / RJEŠENJA */}
                            {/* <td> */}
                            {userRole === "ROLE_SLUZBENIK" ? (
                              <td className="ant_batn">
                                <ButtonComponent
                                  id={`rjesenje-${element.zahtjevId}`}
                                  variant="secondary"
                                  size="sm"
                                  icon={<FormOutlined />}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.openSignatureConfirmationModal(
                                      element.zahtjevAtrId,
                                      "rjesenje"
                                    );
                                  }}
                                  disabled={
                                    element.isRjesenjeDokument === 0 ||
                                    element.rjesenjePotpisano === 1 ||
                                    element.status === 1 ||
                                    element.status === 2
                                  }
                                ></ButtonComponent>
                              </td>
                            ) : userRole === "ROLE_KORISNIK" ? (
                              <td className="ant_batn">
                                <ButtonComponent
                                  id={`potpisivanje-${element.zahtjevId}`}
                                  variant="secondary"
                                  size="sm"
                                  icon={<FormOutlined />}
                                  onClick={(e) => {
                                    console.log(this.state);
                                    e.preventDefault();
                                    this.openSignatureConfirmationModal(
                                      element.zahtjevAtrId,
                                      "zahtjev"
                                    );
                                  }}
                                  disabled={
                                    element.zahtjevPotpisan == 1 ? true : false
                                  }
                                ></ButtonComponent>
                              </td>
                            ) : null}

                            <td
                              style={{
                                textAlign: "center !important",
                                verticalAlign: "middle",
                              }}
                            >
                              <Badge
                                variant={returnBadgeVariant(element)}
                              >
                                {element.status} - {element.statusStr}
                              </Badge>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <div
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  {this.state.searchData.initialItemCount &&
                    this.state.searchData.initialItemCount > 0 ? (
                    <Pagination
                      defaultCurrent={1}
                      defaultPageSize={10}
                      total={this.state.searchData.initialItemCount}
                      responsive
                      onChange={this.onPageChanged}
                      showSizeChanger={false}
                    />
                  ) : null}
                </div>
              </Col>
            </Row>
          </>
        )}
        {/* {this.state.formListData.length === 0 && this.state.dataFetched && (
          <p style={{ textAlign: "center", marginTop: "32px" }}>
            Nema rezultata pretrage
          </p>
        )} */}
        <ModalComponent
          size="xl"
          show={this.state.modal}
          onHide={this.hideModal}
          title={this.state.modalTitle}
        >
          {this.state.requestsLoaded ? (
            <DynamicFormBuilder
              setParentState={this.setInitialFormData}
              url={`/request/${this.state.zahtjevAtrId}?isEdit=${false}`}
              parentState={parentState}
              hideModal={this.hideModal}
            />
          ) : (
            <>
              <Spinner />
            </>
          )}
        </ModalComponent>

        {
          //modal za potpisivanje
        }
        <SignatureModal show={this.state.showSignatureConfirmation} zahtjevAtrId={this.state.zahtjevAtrId} dataType={this.state.vrstaDokumentaZaPotpis}
          onHide={this.closeSignatureConfirmationModal} onCancel={this.closeSignatureConfirmationModal} onFinished={this.getSignedDocument}
        />
       
        <ModalComponent
          size="xl"
          show={this.state.updateModal}
          onHide={this.openConfirmationModal}
          title="Ažuriraj"
        >
          {this.state.requestsLoaded ? (
            <DynamicFormBuilder
              {...searchProps}
              parentState={parentState}
              autocompleteCountryHandler={this.autocompleteCountryHandler}
              autocompleteCityHandler={this.autocompleteCityHandler}
              autocompleteDistrictHandler={this.autocompleteDistrictHandler}
              removeAttachment={this.removeAttachment}
              openConfirmationModal={this.openConfirmationModal}
            />
          ) : (
            <Spinner />
          )}
        </ModalComponent>
        <ModalComponent
          size="sm"
          show={this.state.showConfirmationModal}
          onHide={this.hideConfirmationModal}
          title="Jeste li sigurni da želite odustati od ažuriranja? Promjene neće biti spremljene!"
        >
          <Row>
            <Col>
              <Button type="primary" block onClick={this.hideUpdateModal}>
                Da
              </Button>
            </Col>
            <Col>
              <Button type="danger" block onClick={this.hideConfirmationModal}>
                Ne
              </Button>
            </Col>
          </Row>
        </ModalComponent>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: state.authentication.userData,
    isAuthenticated: state.authentication.isAuthenticated,
    role: state.authentication.userData
      ? state.authentication.userData.roles[0].roleName
      : "",
    authority: state.authentication.authority
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PregledZahtjeva);
